// extracted by mini-css-extract-plugin
export default {"input":"input_input__-6c6s"};